export default __webpack_public_path__ + "static/media/ic-institute-management.48048140.svg";